import { AloIcon, FileCheckIcon } from '../../../assets/icons';
import {
  Megaphone,
  BriefcaseBusiness,
  ChartNoAxesCombined,
} from 'lucide-react';

export const tabItems = [
  {
    id: 'submit',
    label: 'Submit Hotel Data',
    title: 'View Submission',
    icon: FileCheckIcon,
    disabled: false,
  },
  {
    id: 'score',
    label: 'Alō Score',
    title: 'View Alō Score',
    icon: AloIcon,
    disabled: false,
  },
  {
    id: 'travel',
    label: 'Traveler Marketing',
    title: 'View & Edit Traveler Marketing Page',
    icon: Megaphone,
    disabled: false,
  },
  {
    id: 'benchmark',
    label: 'Market Intelligence',
    title: 'View Market Intelligence Data',
    icon: ChartNoAxesCombined,
    disabled: false,
  },
  {
    id: 'hotel-orgs-enterprises',
    label: 'Hotel Organizations & Enterprises',
    title: 'View Hotel Organizations & Enterprises',
    icon: BriefcaseBusiness,
    disabled: false,
  },
];
